import { render, staticRenderFns } from "./studentEduInfoRowsBlocks.vue?vue&type=template&id=1f6276b5&scoped=true&"
import script from "./studentEduInfoRowsBlocks.vue?vue&type=script&lang=ts&"
export * from "./studentEduInfoRowsBlocks.vue?vue&type=script&lang=ts&"
import style0 from "./studentEduInfoRowsBlocks.vue?vue&type=style&index=0&id=1f6276b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6276b5",
  null
  
)

export default component.exports